import { initials } from '../lib/format';
import { kidColor, kidInk } from '../lib/palette';

export function Avatar({ name, color, size = 44 }: { name: string; color: string; size?: number }) {
  return (
    <span className="avatar" style={{ background: kidColor(color), color: kidInk(color), width: size, height: size, fontSize: size * 0.4 }} aria-hidden>
      {initials(name)}
    </span>
  );
}
